export default __webpack_public_path__ + "static/media/glasS.ec88e48d.png";